import { render, staticRenderFns } from "./AdGroupShow.vue?vue&type=template&id=0b609630&scoped=true"
import script from "./AdGroupShow.vue?vue&type=script&lang=js"
export * from "./AdGroupShow.vue?vue&type=script&lang=js"
import style0 from "./AdGroupShow.vue?vue&type=style&index=0&id=0b609630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b609630",
  null
  
)

export default component.exports